import { Logger } from '@thesavingsgroup/logger/Logger';
import type { ContentfulClientApi } from 'contentful';
import { createClient } from 'contentful';
import type { Reporter } from '@thesavingsgroup/reporting/types/Reporter';
import { contentfulLogHandler } from './contentfulLogHandler';
import { contentfulRequestLogger } from './contentfulRequestLogger';
import { contentfulResponseLogger } from './contentfulResponseLogger';
import { DEFAULT_CLIENT_TIMEOUT } from './constants';
import type { AxiosAdapter } from 'axios';

type CreateContentfulClientDependencies = {
  accessToken?: string;
  adapter?: AxiosAdapter;
  environment?: string;
  logger?: Logger;
  reporter: Reporter;
  timeout?: number;
  space?: string;
};

export const createContentfulClient = ({
  accessToken = import.meta.env.VITE_CONTENTFUL_TOKEN,
  adapter,
  environment = import.meta.env.VITE_CONTENTFUL_ENV,
  logger = new Logger(),
  reporter,
  timeout = DEFAULT_CLIENT_TIMEOUT,
  space = import.meta.env.VITE_CONTENTFUL_SPACE,
}: CreateContentfulClientDependencies): ContentfulClientApi<undefined> =>
  createClient({
    accessToken,
    adapter,
    environment,
    logHandler: contentfulLogHandler({ logger }),
    requestLogger: contentfulRequestLogger({ logger, reporter }),
    responseLogger: contentfulResponseLogger({ logger, reporter }),
    space,
    timeout,
  });
